<div class="password-strength" *ngIf="password">
  <!-- Progress bar -->
  <div class="mt-2">
    <small class="text-muted">Password Strength: <strong [ngClass]="{'text-danger': strength?.strength === 'Weak', 'text-warning': strength?.strength === 'Medium', 'text-info': strength?.strength === 'Strong', 'text-success': strength?.strength === 'Very Strong'}">{{ strength?.strength || 'None' }}</strong></small>
    <div class="progress" style="height: 5px;">
      <div class="progress-bar" [ngClass]="progressBarClass" [style.width.%]="progressPercentage"></div>
    </div>
  </div>

  <!-- Requirements checklist -->
  <div class="mt-2" *ngIf="showRequirements">
    <small class="text-muted">Requirements:</small>
    <ul class="list-unstyled small">
      <li *ngFor="let req of requirements" [ngClass]="{'text-success': isRequirementMet(req), 'text-muted': !isRequirementMet(req)}">
        <i class="fa" [ngClass]="{'fa-check': isRequirementMet(req), 'fa-times': !isRequirementMet(req)}"></i>
        {{ req }}
      </li>
    </ul>
  </div>

  <!-- Error messages if invalid -->
  <div *ngIf="strength && !strength.valid" class="alert alert-danger mt-2 small">
    <strong>Password does not meet requirements:</strong>
    <ul class="mb-0 pl-3">
      <li *ngFor="let error of strength.errors">{{ error }}</li>
    </ul>
  </div>
</div>